import { classNames } from 'primereact/utils'
import { PasswordPassThroughOptions } from 'primereact/password'
import { TRANSITIONS } from './transitions'

export const passwordConfig: PasswordPassThroughOptions = {
  root: (options) => ({
    className: classNames('relative', {
      'opacity-60 select-none pointer-events-none cursor-default': options?.props?.disabled,
    }),
  }),
  panel: () => ({
    className: 'hidden p-5 bg-white dark:bg-gray-900 text-gray-700 dark:text-white/80 shadow-md rounded-md',
  }),
  meter: () => ({
    className: 'mb-2 bg-gray-300 dark:bg-gray-700 h-3',
  }),
  meterLabel: ({ state, props }: { state: any; props: any }) => ({
    className: classNames(
      'transition-width duration-1000 ease-in-out h-full',
      {
        'bg-red-500': state.meter?.strength == 'weak',
        'bg-orange-500': state.meter?.strength == 'medium',
        'bg-green-500': state.meter?.strength == 'strong',
      },
      { 'pr-[2.5rem] ': props.toggleMask },
    ),
  }),
  showIcon: {
    className: classNames('absolute top-1/2 -mt-2', 'right-3 text-gray-600 dark:text-white/70'),
  },
  hideIcon: {
    className: classNames('absolute top-1/2 -mt-2', 'right-3 text-gray-600 dark:text-white/70'),
  },
  transition: {
    ...TRANSITIONS.overlay,
    addEndListener: () => {},
  },
}
